export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "fr",
    "resource": {
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Page non trouvée"])}
    }
  })
}
